// designationSlice.ts
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { DesignationState, Designation } from './designationTypes';
import { createDesignation, deleteDesignation, fetchAllDesignations, fetchDesignationById, updateDesignation } from './designationAction';

// Initial State
const initialState: DesignationState = {
    designations: [],
    selectedDesignation: undefined,
    loadingStates: {
        create: false,
        update: false,
        delete: false,
        fetchById: false,
        fetchAll: false,
    },
    errors: {
        create: undefined,
        update: undefined,
        delete: undefined,
        fetchById: undefined,
        fetchAll: undefined,
    },
};

// Slice
const designationSlice = createSlice({
    name: 'designations',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Designation
            .addCase(createDesignation.pending, (state) => {
                state.loadingStates.create = true;
                state.errors.create = undefined;
            })
            .addCase(createDesignation.fulfilled, (state, action) => {
                state.loadingStates.create = false;
                state.designations.push(action.payload);
            })
            .addCase(createDesignation.rejected, (state, action) => {
                state.loadingStates.create = false;
                state.errors.create = action.payload as string;
            })

            // Update Designation
            .addCase(updateDesignation.pending, (state) => {
                state.loadingStates.update = true;
                state.errors.update = undefined;
            })
            .addCase(updateDesignation.fulfilled, (state, action) => {
                state.loadingStates.update = false;
                const index = state.designations.findIndex((d) => d.Id === action.payload.Id);
                if (index !== -1) {
                    state.designations[index] = action.payload;
                }
            })
            .addCase(updateDesignation.rejected, (state, action) => {
                state.loadingStates.update = false;
                state.errors.update = action.payload as string;
            })

            // Delete Designation
            .addCase(deleteDesignation.pending, (state) => {
                state.loadingStates.delete = true;
                state.errors.delete = undefined;
            })
            .addCase(deleteDesignation.fulfilled, (state, action) => {
                state.loadingStates.delete = false;
                state.designations = state.designations.filter((d) => d.Id !== action.payload);
            })
            .addCase(deleteDesignation.rejected, (state, action) => {
                state.loadingStates.delete = false;
                state.errors.delete = action.payload as string;
            })

            // Fetch Designation by ID
            .addCase(fetchDesignationById.pending, (state) => {
                state.loadingStates.fetchById = true;
                state.errors.fetchById = undefined;
            })
            .addCase(fetchDesignationById.fulfilled, (state, action) => {
                state.loadingStates.fetchById = false;
                state.selectedDesignation = action.payload;
            })
            .addCase(fetchDesignationById.rejected, (state, action) => {
                state.loadingStates.fetchById = false;
                state.errors.fetchById = action.payload as string;
            })

            // Fetch All Designations
            .addCase(fetchAllDesignations.pending, (state) => {
                state.loadingStates.fetchAll = true;
                state.errors.fetchAll = undefined;
            })
            .addCase(fetchAllDesignations.fulfilled, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.designations = action.payload.data;
            })
            .addCase(fetchAllDesignations.rejected, (state, action) => {
                state.loadingStates.fetchAll = false;
                state.errors.fetchAll = action.payload as string;
            });
    },
});

export default designationSlice.reducer;
